export function setTaskReducer(state, action) {
  state.task = action.payload;
}
